import Super from '../../core/container.gjs';

export default class SpdsLayoutFlexBase extends Super {
  grid = false;
}
